import { getCurrentInstance, useSlots } from 'vue';

// 通知dialog或drawer更新slot(使用底层的slot)
export function usePopupContainer() {
  // 拿到parent的属性
  const parent = getCurrentInstance()?.parent;

  const popupCtx = (parent?.props?.popupCtx || parent?.attrs?.popupCtx) as any;
  const updateSlot = popupCtx?.updateSlot;

  if (updateSlot) {
    const slots = useSlots();
    updateSlot(slots.header, slots.footer);
  }
}
